export const CONFIGURATION_ERROR = 'CONFIGURATION_ERROR';
